import { Event } from '../Event'
import { ViewerContext } from '../../constants'

export class ExpertUnstarredLeadEvent extends Event {
  static displayName = 'Expert Unstarred Lead'

  static allowedViewerContexts = [ViewerContext.BusinessUser]
}
